// import utils
import dayjs from 'dayjs';

// import types
import {
  PlanningCycle,
  RecurrenceRuleType
} from '../PlanningCycle/PlanningCycle.types';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export function getDefaultStartString() {
  return dayjs().startOf('day').toISOString();
}

export function getWeekOfMonth(dateStr: string): number {
  const date = dayjs(dateStr).toDate();
  const offset = date.getDate() - 1;
  return Math.floor(offset / 7) + 1;
}

export function getNegativeWeekOfMonth(dateStr: string): number {
  const date = dayjs(dateStr).toDate();
  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const offsetDate = lastDayOfMonth.getDate() - date.getDate();
  return (Math.floor(offsetDate / 7) + 1) * -1;
}

export const getRecurrenceRule = (
  currentPlanningCycle: PlanningCycle | null
): RecurrenceRuleType | null => {
  if (currentPlanningCycle) {
    const start = currentPlanningCycle.recurrenceRule?.start;
    const userTimezone = dayjs.tz.guess();

    return {
      start:
        dayjs.utc(start).tz(userTimezone).startOf('day').toISOString() ||
        dayjs().toISOString(),
      periodType: currentPlanningCycle?.recurrenceRule?.periodType,
      interval: currentPlanningCycle?.recurrenceRule?.interval || 1,
      dayInWeekSet: currentPlanningCycle?.recurrenceRule?.dayInWeekSet
        ? currentPlanningCycle?.recurrenceRule?.dayInWeekSet
        : [dayjs().locale('en').format('dddd').toUpperCase()],
      dayOfMonth: currentPlanningCycle?.recurrenceRule?.dayOfMonth,
      setPosition: currentPlanningCycle?.recurrenceRule?.setPosition
    };
  }
  return null;
};
